import React from 'react';
import { Button, Spinner } from 'react-bootstrap';
import { FaRoute } from 'react-icons/fa';

const RouteSummaryBar = ({
  tourEstimateLabel,
  tourMiles,
  canSaveRoute,
  saving,
  onCancel,
  onSave,
  saveTitle = '',
}) => {
  return (
    <div className="route-summary-bar d-flex align-items-center gap-3 flex-wrap">
      <div className="route-summary-details flex-grow-1 text-theme">
        <div className="fw-semibold small">Tour Estimate:</div>
        <div className="fw-semibold small">{tourEstimateLabel}</div>
        <div className="small d-flex align-items-center gap-2 mt-1">
          <FaRoute />
          <span>{tourMiles != null ? `${tourMiles.toFixed(1)} mi` : '--'}</span>
        </div>
      </div>
      <div className="route-summary-actions d-flex gap-2 ms-auto">
        <Button
          className="route-summary-action-btn route-summary-cancel-btn"
          variant="danger"
          disabled={saving}
          onClick={onCancel}
          title="Cancel editing"
        >
          Cancel
        </Button>
        <Button
          className="route-summary-action-btn"
          variant={!canSaveRoute || saving ? 'secondary' : 'primary'}
          disabled={!canSaveRoute || saving}
          onClick={onSave}
          title={saveTitle || 'Save tour'}
        >
          {saving ? <Spinner animation="border" size="sm" className="me-2" /> : null}
          Save
        </Button>
      </div>
    </div>
  );
};

export default RouteSummaryBar;
